export const POSTHOG_FEATURE_FLAGS = {
  PD_OPPORTUNITY_DRAFTS: 'pd_opportunity_drafts',
  PD_GRANTS_CSV_EXPORT: 'pd_grants_csv_export',
  PD_GRANTS_CANDIDATE_TIMELINE: 'pd_grants_candidate_timeline',
  PD_GIVING_CAMPAIGN_GROUPS: 'pd_giving_campaign_groups',
  PD_DONATION_SUMMARY_CHARTS: 'pd_donation_summary_charts',
  PD_INSIGHTS_REPORTS: 'pd_insights_reports',
  PD_INSIGHTS_REPORTS_GRANTS: 'pd_insights_reports_grants',
  PD_GIVING_ACTIONS: 'pd_giving_actions',
  PD_DONATION_CATEGORY_FILTER: 'pd_donation_category_filter',
  PD_INSIGHTS_AI_CHAT: 'pd_insights_ai_chat',
  PD_INSIGHTS_AI_DEBUG_EXPORT: 'pd_insights_ai_debug_export',
  PD_VOLUNTEERING_REWARDS_VISIBILITY: 'pd_volunteering_rewards_visibility',
  PD_ORG_PROFILES: 'pd_org_profiles'
} as const

export type PostHogFeatureFlag = typeof POSTHOG_FEATURE_FLAGS[keyof typeof POSTHOG_FEATURE_FLAGS]
